import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Tabs } from 'antd';
import OverView from './OverView';
import Promotion from './Promotion';
import Vacation from './Vacation';
import Leave from './Leave';
import BusinessTrip from './BusinessTrip';
import ChargeHospital from './ChargeHospital';
import Recommend from './Recommend';
import Approve from './Approve';
import UserSider from '../UserSider';

const { TabPane } = Tabs;

class UserInfo extends Component {
    constructor(props) {
        super(props);
        const { activeKey = 'overView', employeeCode } = props.params;
        this.state = {
            panes: [{
                title: '人员信息总览',
                key: 'overView',
                content: null,
            }, {
                title: '人员带教/晋升',
                key: 'promotion',
                content: null,
            }, {
                title: '人员休假',
                key: 'vacation',
                content: null,
            }, {
                title: '人员离职',
                key: 'leave',
                content: null,
            }, {
                title: '人员短期驻外/出差',
                key: 'businessTrip',
                content: null,
            }, {
                title: '人员主要/次要负责医院科室',
                key: 'chargeHospital',
                content: null,
            }, {
                title: '人员内部成功推荐',
                key: 'recommend',
                content: null,
            }, {
                title: '人员获得客户/研究者非邮件形式认可',
                key: 'approve',
                content: null,
            }],
            params: {},
            activeKey, 
            employeeCode,
        };
    }

    componentDidMount() {
        this.updatePanes();
    }

    updatePanes = () => {
        const { panes, params, activeKey, employeeCode } = this.state;
        let RenderContent = null;
        if (activeKey == 'overView') {
            RenderContent = OverView;
        } else if (activeKey == 'promotion') {
            RenderContent = Promotion;
        } else if (activeKey == 'vacation') {
            RenderContent = Vacation;
        } else if (activeKey == 'leave') {
            RenderContent = Leave;
        } else if (activeKey == 'businessTrip') {
            RenderContent = BusinessTrip;
        } else if (activeKey == 'chargeHospital') {
            RenderContent = ChargeHospital;
        } else if (activeKey == 'recommend') {
            RenderContent = Recommend;
        } else if (activeKey == 'approve') {
            RenderContent = Approve;
        }
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = <RenderContent params={params} employeeCode={employeeCode} onChange={(activeKey, params) => this.handleTabsChange(activeKey, params)} />;
            } else {
                item.content = null;
            }
        });
        this.setState({ panes });
    }

    handleTabsChange = (activeKey, params = {}) => {
        this.setState({
            params,
            activeKey,
        }, () => {
            this.updatePanes();
        });
    }

    render() {
        const { panes, activeKey } = this.state;
        return (
            <div className="content pmInfo">
                <UserSider selectKey='userInfo' openKeys={['sub1']}/>
                <div className="main">
                    <div className="main-content">
                        <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                            {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content}</TabPane>)}
                        </Tabs>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
};

export default connect(mapStateToProps, null)(UserInfo);


// WEBPACK FOOTER //
// ./src/components/user/userInfo/index.js